import React from "react";
import { MapPin } from "lucide-react";
import { legalTeam, legalSectionCopy } from "../content/team";

import { tr } from "../i18n";
export default function TeamSection() {
  return (
    <section id="legal-compliance" className="bg-[#f6f2e9] py-20 md:py-28 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        {/* Heading */}
        <div className="text-center max-w-2xl mx-auto mb-14 reveal">
          <div className="deco-line w-24 mx-auto mb-6" />
          <p className="text-[#c2a15a] text-[13px] tracking-[0.25em] uppercase mb-3">
            {tr("Our practice")}
          </p>
          <h2 className="font-display text-[34px] md:text-[46px] text-[#0b1f3a] leading-tight">
            {legalSectionCopy.heading}
          </h2>
          <p className="text-[#0b1f3a]/60 text-[17px] mt-4">
            {legalSectionCopy.subtitle}
          </p>
        </div>

        {/* Grid: 1 / 2 / 4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {legalTeam.map((p, i) => (
            <div
              key={p.name}
              className="reveal group relative rounded-2xl bg-white ring-1 ring-[#0b1f3a]/8 overflow-hidden transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-[#0b1f3a]/10 hover:ring-[#c2a15a]/40"
              style={{ transitionDelay: `${(i % 4) * 60}ms` }}
            >
              {/* Portrait */}
              <div className="relative overflow-hidden">
                <img
                  src={p.image}
                  alt={tr("{v0} (fictional illustrative persona)", { v0: p.name })}
                  loading="lazy"
                  className="w-full h-72 object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/40 to-transparent" />
              </div>

              {/* Body */}
              <div className="p-5">
                <h3 className="font-display text-[20px] text-[#0b1f3a] leading-snug">
                  {p.name}
                </h3>
                <p className="text-[13px] font-medium text-[#0b1f3a]/70 mt-1">
                  {p.role}
                </p>
                <p className="flex items-center gap-1.5 text-[12px] text-[#0b1f3a]/45 mt-1.5">
                  <MapPin size={12} className="text-[#c2a15a]" />
                  {p.location}
                </p>
                <div className="mt-3 pt-3 border-t border-[#0b1f3a]/8">
                  <p className="text-[11px] uppercase tracking-widest text-[#0b1f3a]/40">
                    {tr("Focus")}
                  </p>
                  <p className="text-[14px] text-[#0b1f3a]/80 mt-1">{p.focus}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
